import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb'; 
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'atw-text-categoty-name-config',
  templateUrl: './text-categoty-name-config.component.html',
  styleUrls: ['./text-categoty-name-config.component.scss']
})

export class AtwTextCategotyNameConfig implements OnInit {
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() type_config: string; // xác định trang đang ở page hay preview
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  // @Input() id_subproject : any;

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'hieu_ung_chuyen_dong',
      index: 1,
    },
    {
      title: 'cau_hinh_bo_goc',
      index: 2,
    }
  ];

  fonts = [];
  effect_hover = [];
  effect_hover_data: any = {};

  dataAfterChange: any = {}
  arr_link_page: any;
  id_subproject: any = "";
  link_type: any = [
    {
      name: 'Mở trong trang mới',
      value: '_blank'
    },
    {
      name: 'Mở trong trang hiện tại',
      value: '_self'
    }
  ]
  text_style: any = [
    {
      title: 'tieu_de_1',
      fontSize: '68px',
      name: 'h1',
      font: 21
    },
    {
      title: 'tieu_de_2',
      fontSize: '48px',
      name: 'h2',
      font: 19
    },
    {
      title: 'tieu_de_3',
      fontSize: '36px',
      name: 'h3',
      font: 18
    },
    {
      title: 'tieu_de_4',
      fontSize: '26px',
      name: 'h4',
      font: 17
    },
    {
      title: 'tieu_de_5',
      fontSize: '20px',
      name: 'h5',
      font: 16
    },
    {
      title: 'tieu_de_6',
      fontSize: '18px',
      name: 'h6',
      font: 15
    },
    {
      title: 'van_ban',
      fontSize: '18px',
      name: 'p',
      font: 14
    },
    {
      title: 'van_ban_quan_trong',
      fontSize: '18px',
      name: 'strong',
      font: 14
    },
    {
      title: 'van_ban_nho',
      fontSize: '16px',
      name: 'small',
      font: 13
    },
    {
      title: 'trich_dan',
      fontSize: '18px',
      name: 'Blockquote',
      font: 14
    }
  ];
  /** Danh sách giải thích loại văn bản tương ứng SEO */
  seoTextTypes: any = [
    { tag: 'tieu_de_1', explain: 'dung_cho_tieu_de_chinh', usage: 'chi_dung_mot_lan_trong_trang' },
    { tag: 'tieu_de_2_den_tieu_de_6', explain: 'dung_cho_cac_tieu_de_phu', usage: 'dung_theo_thu_tu_phan_cap_khong_bo_bac' },
    { tag: 'van_ban', explain: 'dung_cho_van_ban' },
    { tag: 'van_ban_quan_trong', explain: 'dung_cho_van_ban', usage: 'chi_de_nhan_y_quan_trong_dung_tiet_che' },
  ];

  @Output() save = new EventEmitter();
  @Output() closeConfigEvent = new EventEmitter();
  @Output() closeConfigTool = new EventEmitter();

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private vhEventMediator: VhEventMediator
  ) {
    
  }

  ngOnInit(): void {
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
      this.http.get('assets/data/effects/text.json'),
    ]).subscribe(([fonts, effects]: any) => {
      this.fonts = fonts;
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    });

    if (!this.config.text_type) {
      this.config.text_type = 'p';
    }
    if (!this.config.curve) {
      this.config.curve = {
        "radius": "170",
        "angle": "100",
        "rotate": "-85",
        "isCurve": false,
        "isCurveReverse": false
      }
    }
    if (!this.class['text-category-name__curve']) {
      this.class['text-category-name__curve'] = {
        "list-style": "none",
        "font-family": "inherit",
        "width": "340px",
        "height": "340px"
      };
    }
    if (!this.class['text-category-name__curve-item']) {
      this.class['text-category-name__curve-item'] = {
        "background-image": "",
        "height": "100%",
        "left": "50%",
        "top": "0px",
        "position": "absolute",
        "transform-origin": "center",
        "font-family": "inherit"
      };
    }
  }

  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }

  ngOnDestroy(): void {
    this.saveDataProperties()
  }

  customize = []

  /**
   * Hàm update class
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        
      })
  }

  /**
   * Hàm update config
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {
        
      })
  }

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        
      })
  }

  /**
   * Set style changed
   * @param name : tên trường data cần lưu
   * @param value : giá trị data
   */
  updateCss(name, key) {
    // lấy tên và giá trị style đã thay đổi.
    this.dataAfterChange[name] = { ...key }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại. 
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false
  };
  /**
    * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
    * @param event customize sau khi thay đổi
    */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[0])
  }

  /**
   * Cập nhật lưu data vào database.
   */
  saveDataProperties() {
    if (Object.keys(this.dataAfterChange).length)
      this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, this.dataAfterChange)
        .then((bool) => {
          
        }, error => {
          console.error(error)
        })
  }
  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['text-category-name']['width'] = event.width + 'px';
    if (event.height) this.class['text-category-name']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }

  /**
   * Cập nhật Kiểu văn bản
   */
  handleSetTextStyle(action) {
    this.class['text-category-name__content']['font-size'] = this.text_style.find(style => style.name === action)['fontSize'];
    switch (action) {
      case "Blockquote":
        this.class['text-category-name__content']['border-left-width'] = '10px';
        this.class['text-category-name__content']['padding-left'] = '10px';
        break;
      default:
        this.class['text-category-name__content']['border-left-width'] = '0';
        this.class['text-category-name__content']['padding-left'] = '0';
    }

    // this.handleSetCurveText();

    this.updateObject();
  }
}
